import React, {
    useContext, useEffect, useRef, useState
} from 'react';
import {
    useNavigate, useSearchParams, Link
} from 'react-router-dom';
import {
    Context
} from 'shared/context/GlobalState';
import SignupForm from './SignupForm';
import {
    authService
} from 'shared/api';
import loginLogo from 'assets/login-logo.png';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';

export default function Signup() {

    const [btnLoading, setBtnLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);

    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');

    const signupFormRef = useRef(null);

    const {
        addNewNotifcation
    } = useContext(Context);
    const navigate = useNavigate();

    const checkToken = async () => {
        if (token) {
            setLoading(true);
            try {
                await authService.verifyInvitationToken(token);
                setShowForm(true);
            } catch (error) {
                console.log('error: ', error);
                setShowForm(false);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        checkToken();
    }, []);

    const handleOnSubmit = (e) => {
        e.preventDefault();

        const nameRef = signupFormRef.current.getNameRef();
        const emailRef = signupFormRef.current.getEmailRef();
        const passwordRef = signupFormRef.current.getPasswordRef();
        const confirmPasswordRef = signupFormRef.current.getConfirmPasswordRef();

        if (passwordRef.value !== confirmPasswordRef.value) {
            addNewNotifcation('Signup failed. Password does not match. Please enter the same password for confirmation.','danger');
            return;
        }

        if (passwordRef.value.length < 8) {
            return addNewNotifcation('Singup failed. Password length must be at least 8 characters long. Please reenter your password.','danger');
        }

        const turnstileToken = signupFormRef.current.getTurnstileToken();

        setBtnLoading(true);

        const userOBj = {
            name: nameRef.value,
            email: emailRef.value,
            password: passwordRef.value,
            turnstileToken,
        };

        if (token) {
            userOBj['token'] = token;
        }

        authService.signup(userOBj)
            .then((res) => {
                console.log(res);
                addNewNotifcation('Your account was created successfully. Please verify your account by using the verification link sent to your email.','success', 6);
                setTimeout(() => {
                    navigate('/auth/login');
                }, 1500);
            }).catch((error) => {
                console.log('error: ', error);
                if (error.response?.status === 409) {
                    addNewNotifcation('Signup failed. Email is already registered. Please use a different email.','danger');
                } else if (error.response?.status === 400) {
                    addNewNotifcation(error.response.data?.message || 'Signup failed. Please check all your entries.','danger');
                } else {
                    addNewNotifcation('Signup failed. Please check all your entries.','danger');
                }
                // The failed attempt spent the single-use Turnstile token; reset
                // the widget so a retry gets a fresh one (else it fails until reload).
                signupFormRef.current?.resetTurnstile?.();
            }).finally(() => {
                setTimeout(() => setBtnLoading(false), 1500);
            });

    };

    if (loading) {
        return <div className='flex flex-grow flex-col justify-center items-center'> <AppLoader size={50} /> </div>;
    }

    return (
        <div className='flex flex-grow flex-col justify-center items-center'>
            <div>
                <div className='w-full text-center mt-12'>
                    <h1 className='text-4xl font-bold mb-6'> BeX AI Platform </h1>
                    <h3 className='text-2xl font-bold md:block hidden'> Agentic AI Platform for Workflow Orchestration </h3>
                </div>
                <div className='flex md:flex-row flex-col items-center gap-8 mt-4'>
                    {!showForm ? (
                        <div className='w-full text-center max-w-md md:max-w-[500px]'>
                            <p className='text-justify'>
                                Hi there, thanks for your interest.  Due to overwhelming demand, we have suspended auto-sign up. <br />
                                Please send an email to <strong> discovery@coolriots.com </strong> if you are interested in a trial access and we will arrange for a demo and assist you to onboard to our Agentic AI Workflow platform.  Thank you again for your understanding.
                            </p>
                            <div className="mt-6 text-center text-sm">
                                <Link
                                    to="/auth/login"
                                    className="font-medium text-[#B1092A] underline underline-offset-2 hover:text-[#8d0721] focus:text-[#8d0721]"
                                >
                                    Return to login
                                </Link>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className='max-w-md md:max-w-[500px] w-full order-last md:order-first flex flex-col gap-4'>
                                <img src={loginLogo} alt="login-image" className='order-last md:order-first' />
                                <h3 className='text-2xl text-center text-red-500 font-bold'> AI that gets Business Execution Done </h3>
                            </div>
                            <div className='flex flex-col w-full'>
                                <SignupForm ref={signupFormRef} loading={btnLoading} onSubmit={handleOnSubmit} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export const ContainerPass = ({
    labelName, children
}) => {
    return (
        <div className='input-container'>
            <label>{labelName}</label>
            <div className='input-wrapper'>
                {children}
                {/* <span className='password-toggle'></span> */}
            </div>
        </div>
    );
};
